module.exports = __webpack_public_path__ + "img/outsorsing-banner-bg.636b8730.jpg";